(function autosearch($) {

	class Autosearch {
		constructor (element, settings) {
			this.marker = null;
			this.init(element, settings);
		}

		init (element, settings) {
			const $map = $(element).find('.autocomplete-map');
			const $input = $(element).find('.autocomplete-input');
			const autocomplete = new google.maps.places.Autocomplete($input[0], {
				types: ['address']
			});

			const map = new google.maps.Map($map[0], {
				center: {lat: 51.9614997, lng: 18.11389},
				zoom: 5,
				disableDefaultUI: true,
				mapTypeId: 'roadmap',
				zoomControl: true
			});

			$input.on('focus', () => this.geolocate(autocomplete));

			autocomplete.addListener('place_changed', () => {
				const place = autocomplete.getPlace();

				// rozszerzenie obkietu places o numer mieszkania
				const flatNumber = this.getFlatNumber($input);
				if (place.address_components) {
					place.address_components.push({
						long_name: flatNumber,
						types: ["flat_number"]
					});
				}

				this.fillInAddress(settings.componentForm, place);
				this.updateMap(map, place);
			});
		}

		getFlatNumber ($input) {
			const pattern = /\s([0-9a-z+]+)(\/|-)([0-9a-z]+)/i; // szukamy w adresie numeru mieszkania np. 1/4, 1/4a, 1b/4, 1-6
			const result = $input.val().trim().match(pattern);
			return result ? result[3] : '';
		}

		deleteMarker () {
			this.marker.setMap(null);
			this.marker = null;
		}

		updateMarker (map, place) {
			if (this.marker) {
				this.deleteMarker();
			}
			this.marker = new google.maps.Marker({
				map: map,
				title: place.name,
				position: place.geometry.location
			});
		}

		updateMap (map, place) {
			if (!place || !place.geometry) {
				return;
			}
			this.updateMarker(map, place);
			map.panTo(place.geometry.location);
			map.setZoom(16);
		}

		fillInAddress (componentForm, place) {
			Object.keys(componentForm).forEach(component =>
				$(`#${componentForm[component]}`).val('')
			);
			
			if (place.address_components) {
				place.address_components.forEach(component => {
					const addressType = component.types[0];
					if(componentForm[addressType]) {
						const value = component[ "long_name" ];
						$(`#${componentForm[addressType]}`).val(value);
					}
				});
			}
		}

		geolocate (autocomplete) {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function(position) {
					var geolocation = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					};
					var circle = new google.maps.Circle({
						center: geolocation,
						radius: position.coords.accuracy
					});
					autocomplete.setBounds(circle.getBounds());
				});
			}
		}
	}
	
	$.fn.autosearch = function (options) {
		return this.each((index, el) =>
			el.autosearch = new Autosearch(el, options)
		)
	};
	
}(jQuery));